export default __webpack_public_path__ + "static/media/metabox-block-thumbnail-light.d53c0420.svg";